import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Contact from '../home/components/Contact';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://fmacrew.com';

const CONTACT_HERO_IMAGE = "https://public.readdy.ai/ai/img_res/302230a880d802f3d54113f409e24edd.jpg";

export default function ContactPage() {
  const { t } = useTranslation();
  return (
    <>
      <title>Contact | FMA Crew — Free Estimate Atlanta GA</title>
      <meta
        name="description"
        content="Get a free estimate from FMA Crew for apartment maintenance, residential remodeling, or commercial remodeling in Greater Atlanta, GA. Response within 24 hours."
      />
      <link rel="canonical" href={`${SITE_URL}/contact`} />
      <main className="min-h-screen bg-white">
        <Navbar />
        <PageHero
          title={t('contact.hero.title')}
          titleEm={t('contact.hero.titleEm')}
          image={CONTACT_HERO_IMAGE}
        />
        <Contact />
        <Footer />
      </main>
    </>
  );
}